import './legacy_jquery'

let ready_support;

ready_support = function () {
  $('.ticket-list-item').each(function () {
    var container, embed;
    container = $(this);
    embed = $(this).find('.ticket-reply-embed-content');
    return embed.load(embed.data('url'), function () {
      return $(container).click(function () {
        if (!window.getSelection().isCollapsed) {
          return;
        }
        $(container).find('.article-embed-content-preview').toggle();
        $(container).find('.article-embed-content-collapse').toggle();
        container.toggleClass('open');
        return container.toggleClass('bg-light-subtle');
      });
    });
  });
  return $('.ticket-list-show-collapsed-item').click(function () {
    $(this).remove();
    return $('.ticket-list-item').removeClass('collapse');
  });
};

$(document).ready(ready_support);

$(document).on('turbo:load', ready_support);